
















































import { Component, Mixins } from "vue-property-decorator";
import { ContentService } from "@/service/content.service";
import { MatchNoneCDCContent } from "@/models/content/match-none-cdc";
import CommonMixin from "@/mixins/common-mixins";
import { AppData } from "@/models/app-data";
import PageLoader from "@/components/PageLoader.vue"

@Component({
  components: {PageLoader},
})
export default class MatchNoneCDC extends Mixins(CommonMixin) {
  contentService = new ContentService();
  content: MatchNoneCDCContent = {} as MatchNoneCDCContent;
  appData = {} as AppData;
  textDirection = 'ltr'
  loadDataFinished = false;

  async mounted(): Promise<void> {
    try {
      const contentService = new ContentService(this.$route);
      this.content = await contentService.getMatchNoneCDCContent();
      this.textDirection = contentService.TextDirection();      

      this.appData = this.getAppData();
      if ( this.appData != null){
        this.appData.preferredProgram = '';
        this.saveAppData(this.appData);
        await this.putWorkflowStep( this.appData.workflowId, "MatchNoneCDC") 
        await this.postWorkflowNotEligible(this.appData?.workflowId);
      }

      this.postNavigatedToParent();
      this.loadDataFinished = true;
    } catch (error) {
      this.showError(error as any);
    }
  }

  public async handleApply(): Promise<void> {
    window.open( this.content.ButtonApplyLink, "_blank"); 
    await this.publishWebCDCClickEvent( this.appData.workflowId) 
  }
}
